var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 26339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 20H0V18C0 16.1435 0.737477 14.363 2.05023 13.0503C3.36299 11.7375 5.14348 11 7 11H13C14.8565 11 16.637 11.7375 17.9498 13.0503C19.2625 14.363 20 16.1435 20 18V20ZM2 18H18C18 16.6739 17.4732 15.4021 16.5355 14.4645C15.5978 13.5268 14.3261 13 13 13H7C5.67392 13 4.40216 13.5268 3.46448 14.4645C2.5268 15.4021 2 16.6739 2 18Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 10C9.0111 10 8.04442 9.70676 7.22217 9.15735C6.39992 8.60794 5.75906 7.82705 5.38062 6.91342C5.00218 5.99979 4.90315 4.99446 5.09607 4.02455C5.289 3.05465 5.76522 2.16373 6.46448 1.46447C7.16374 0.765207 8.05463 0.289002 9.02454 0.0960763C9.99444 -0.0968498 10.9998 0.00216499 11.9134 0.380603C12.827 0.759041 13.6079 1.39991 14.1574 2.22215C14.7068 3.0444 15 4.0111 15 5C15 6.32609 14.4732 7.59785 13.5355 8.53554C12.5978 9.47322 11.3261 10 10 10ZM10 2C9.40666 2 8.82666 2.17595 8.33332 2.50559C7.83997 2.83524 7.4554 3.30377 7.22833 3.85195C7.00127 4.40013 6.94186 5.00333 7.05762 5.58527C7.17337 6.16722 7.45911 6.70176 7.87866 7.12132C8.29822 7.54088 8.83279 7.8266 9.41474 7.94236C9.99668 8.05812 10.5999 7.9987 11.1481 7.77164C11.6963 7.54458 12.1647 7.16006 12.4944 6.66671C12.824 6.17337 13 5.59335 13 5C13 4.20435 12.6839 3.44129 12.1213 2.87868C11.5587 2.31607 10.7957 2 10 2Z",
    fill: "white",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d3d890bc01a87338c36d9c6aea141f46.svg";
export { ForwardRef as ReactComponent };